<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="600px" persistent>
      
      <v-card>
        <v-card-title>
          <span class="headline">{{titulo}} User</span>
        </v-card-title>
        <v-alert :value="alertErrorPost"
                type="error"
                transition="scale-transition"
                color="error">
                <h4>Error:</h4>
            <ul>
              <li type="circle" v-for="(i) in arrayErrorPost" :key="i.value">
                  <h6>{{i.id}}</h6>
              </li>
          </ul>
        </v-alert>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md6>
                  <v-text-field v-model="modeloUsuario.name" label="User Name*" required></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field v-model="modeloUsuario.email" label="Email*" required></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field v-model="modeloUsuario.PhoneNumber" label="Phone Number*" required></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field v-model="modeloUsuario.Alias" label="Alias*" required></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field v-model="modeloUsuario.Password" label="Password*" type="password" required></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field v-model="modeloUsuario.confirmPassword" label="Confirm your password*" type="password" required></v-text-field>
                </v-flex>
              </v-layout>
              
            </v-container>
            <small>*Required field</small>
          </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error"  @click="cancelar" outlined>Cancel
              <v-icon right dark>cancel</v-icon>
          </v-btn>
          <v-btn color="#008ACD" v-on:click="guardarUsuario()" outlined>Save
              <v-icon right dark>save</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import HTTP from '../../services/index';
import { throws } from 'assert';
import Vue from 'vue'

  export default {
    data: () => ({
      arrayErrorPost:[],
      alertErrorPost:false,
      //dialog: false,
      modeloUsuario: {
        email:'',
        PhoneNumber:'',
        Alias:'',
        Name:'',
        Password:'',
        confirmPassword:'',
        isAdmin:false
      }
    }),
    props:{
      dialog:Boolean,
      email:String,
      titulo:String
    },
    created()  {
      
    },
    mounted() {
     
    },
    methods: {
      

      cancelar(){
        this.reset()
        this.$emit('cancelar')
        this.alertErrorPost=false;
      },

      lanzar_alerta(Type,Title,Text,Footer){
        this.$swal.fire({
          type: Type,
          title: Title,
          text: Text,
          footer: Footer,
           allowOutsideClick: false
        });
      },
      pushError(error){
        Object.keys(error).forEach((element,key,_array)=>{
          if(error[element].hasOwnProperty('description'))
            this.arrayErrorPost.push({ id: error[element].description });
          
          if(error[element].hasOwnProperty('email'))
            this.recorrerErroresGenerico(error[element].email)


          if(error[element].hasOwnProperty('confirmPassword'))
            this.recorrerErroresGenerico(error[element].confirmPassword)            

          if(error[element].hasOwnProperty('Password'))
            this.recorrerErroresGenerico(error[element].Password)

          if(error[element].hasOwnProperty('PhoneNumber'))
            this.recorrerErroresGenerico(error[element].PhoneNumber)

          if(error[element].hasOwnProperty('Alias'))
            this.recorrerErroresGenerico(error[element].Alias)
        });
      },

      recorrerErroresGenerico(error){
        Object.keys(error).forEach((element,key,_array)=> {
          this.arrayErrorPost.push({ id: error[element] });
        });
      },

      guardarUsuario() {  
        //this.modeloUsuario.email=this.email
        HTTP.post('/usuarios/createUser',this.modeloUsuario)
        .then(data => {
          this.alertErrorPost=false;
          this.lanzar_alerta('success', '¡ Good !', 'User added successfully !');
          this.reset();
          this.$emit('usuarioAgregado')
        }).catch(error => {
          this.arrayErrorPost=[]
          this.alertErrorPost=true
          this.pushError(error.response.data)
        })
      },
      reset(){
        this.alertErrorPost=false
        this.modeloUsuario.email='';
        this.modeloUsuario.Password='';
        this.modeloUsuario.confirmPassword='';
        this.modeloUsuario.phone=''
      } 
    },
  }
</script>